import styled from 'styled-components'

export const Container = styled.div`
    margin: 20px;  
    @media (max-width: 768px) {
        width: 100%; // Full screen on mobile devices
        margin: 10px 0;  

    }
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px;
  padding: 20px;
  background-color: white;
  border-radius: 10px;
  width: ${props => props.width || '70%'};
  max-height: 80vh;
  overflow-y: auto;
  
  @media (max-width: 768px) {
    width: 90%;
    margin: 10px;
  }

  // Optional: Custom scrollbar styling
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0,0,0,0.2);
    border-radius: 4px;
  }
`;

export const BookingModalContent = styled.div`
    display: flex;
    flex-direction: column;
    margin: 20px;
    padding: 20px;
    background-color: white;
    border-radius: 10px;
    width: 80vw;
    max-height: 80vh;
    @media (max-width: 768px) {
        width: 100%; // Full screen on mobile devices
        margin: 10px 0;  
    }
`

export const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 20px;
`

export const GridItemStyle = styled('div')(() => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  '& .MuiTypography-root': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%'
  }
}));